import React from "react";
import { Row, Col, Form, Button } from "react-bootstrap";
import Select from "react-select";

const ViewEmployeeFilter = ({
    role,
    employeeOptions,
    departmentOptions,
    subDeptOptions,
    resourceTypeOptions,

    empId,
    setEmpId,
    departmentName,
    setDepartmentName,
    subDepartment,
    setSubDepartment,
    resourceType,
    setResourceType,
    approval,
    setApproval,

    onSearch,
    onClear
}) => {

    const commonSelectProps = {
        menuPortalTarget: document.body,
        styles: {
            menuPortal: (base) => ({ ...base, zIndex: 9999 })
        }
    };

    return (
        <Row className="mb-3 p-3 rounded bg-light">

            {/* 🔹 TEAM LEAD */}
            {(role === "teamlead" || role === "manager") && (
                <>
                    <Col md={4}>
                        <Form.Label>Employee</Form.Label>
                        <Select
                            options={employeeOptions}
                            value={empId}
                            onChange={setEmpId}
                            {...commonSelectProps}
                        />
                    </Col>

                    <Col md={4} className="d-flex align-items-end gap-3">
                        <Button className="primaryBtn" onClick={onSearch}>Search</Button>
                        <Button className="clearBtn" onClick={onClear}>Clear</Button>
                    </Col>
                </>
            )}

            {/* 🔹 HR */}
            {role === "humanResource" && (
                <>
                    <Col md={3}>
                        <Form.Label>Employee</Form.Label>
                        <Select
                            options={employeeOptions}
                            value={empId}
                            onChange={setEmpId}
                            {...commonSelectProps}
                        />
                    </Col>

                    <Col md={3}>
                        <Form.Label>Department</Form.Label>
                        <Select
                            options={departmentOptions}
                            value={departmentName}
                            onChange={setDepartmentName}
                            {...commonSelectProps}
                        />
                    </Col>

                    <Col md={3}>
                        <Form.Label>Sub Department</Form.Label>
                        <Select
                            options={subDeptOptions}
                            value={subDepartment}
                            onChange={setSubDepartment}
                            {...commonSelectProps}
                            isDisabled={!departmentName}
                        />
                    </Col>

                    <Col md={3}>
                        <Form.Label>Resource Type</Form.Label>
                        <Select
                            options={resourceTypeOptions}
                            value={resourceType}
                            onChange={setResourceType}
                            {...commonSelectProps}
                        />
                    </Col>

                    <Col md={4}>
                        <Form.Label>Approval</Form.Label>
                        <Select
                            options={[
                                { value: true, label: "Approved" },
                                { value: false, label: "Rejected" },
                                // { value: null, label: "Not Update" }
                            ]}
                            value={approval}
                            onChange={setApproval}
                            {...commonSelectProps}
                        />
                    </Col>

                    <Col md={4} className="d-flex align-items-end gap-3">
                        <Button className="primaryBtn" onClick={onSearch}>Search</Button>
                        <Button className="clearBtn" onClick={onClear}>Clear</Button>
                    </Col>
                </>
            )}

        </Row>
    );
};

export default ViewEmployeeFilter;